import { makeAutoObservable, autorun } from 'mobx';

class ThemeStore {
  theme: 'light' | 'dark' = (localStorage.getItem('theme') as 'light' | 'dark') ?? 'dark';

  constructor() {
    makeAutoObservable(this);
    autorun(() => {
      document.documentElement.classList.toggle('dark', this.theme === 'dark');
      localStorage.setItem('theme', this.theme);
    });
  }

  toggle = () => {
    this.theme = this.theme === 'dark' ? 'light' : 'dark';
  };
}

export const themeStore = new ThemeStore();
